import axios from 'axios'

import { toCamelCase } from '../lib/typeHelper'
import type { DocumentType } from './document'

export interface FileUpload {
  documentId: string
  attachmentId: string
  fileName: string
  fileExtension: string
  fileSize: number
  fileUrl: string | null
}

export async function uploadFile(
  file: File,
  options?: { documentType?: DocumentType; organisationId?: string }
): Promise<FileUpload> {
  const formData = new FormData()
  formData.append('files', file)
  if (options?.documentType) {
    formData.append('document_type', options.documentType)
  }
  if (options?.organisationId) {
    formData.append('organisation_id', options.organisationId)
  }
  const res = await axios.post('/api/v1/insure/uploads/', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
  const body = toCamelCase(res.data) as { uploads: FileUpload[] }
  if (!body.uploads.length) {
    throw new Error('Upload response did not include any files.')
  }
  return body.uploads[0]
}

export async function deleteFileUpload(documentId: string): Promise<void> {
  await axios.delete(`/api/v1/insure/uploads/${documentId}/`)
}
